<section class="cp" id="confianza">
  <div class="cp__container">
    <div class="cp__header">
      <p class="cp__label">Confianza</p>
      <h2 class="cp__title">Detrás de cada alta, un equipo que da la cara</h2>
      <p class="cp__intro">
        Empresas como la tuya, y una persona con nombre y apellidos al otro
        lado.
      </p>
    </div>

    <div class="cp__grid">
      @for (t of testimonios(); track $index) {
        <figure class="cp__card">
          <div class="cp__card-head">
            <span class="cp__mark" aria-hidden="true">“</span>
          </div>
          <blockquote class="cp__quote">{{ t.quote }}</blockquote>
          <figcaption class="cp__author">
            <span
              class="cp__avatar"
              aria-hidden="true"
              [style.color]="t.color"
              [style.background]="
                'color-mix(in srgb, ' + t.color + ' 18%, transparent)'
              ">
              {{ t.initials }}
            </span>
            <span class="cp__author-info">
              <span class="cp__author-name">{{ t.name }}</span>
              <span class="cp__author-role">{{ t.role }}</span>
            </span>
          </figcaption>
        </figure>
      }

      <!-- Quién hay detrás -->
      <article class="cp__card cp__card--founder">
        <p class="cp__founder-kicker">{{ founder.kicker }}</p>
        <p class="cp__quote">{{ founder.body }}</p>
        <div class="cp__author">
          <img
            class="cp__photo"
            [src]="founder.photo"
            width="52"
            height="52"
            loading="lazy"
            alt="Raúl Alemany Pérez, fundador de TodoSector" />
          <span class="cp__author-info">
            <span class="cp__author-name">{{ founder.name }}</span>
            <span class="cp__author-role">{{ founder.role }}</span>
          </span>
        </div>
      </article>
    </div>

    <div class="cp__badges">
      @for (b of badges; track b.label) {
        <span class="cp__badge">
          <span
            class="cp__badge-hex"
            aria-hidden="true"
            [style.background]="b.color"></span>
          {{ b.label }}
        </span>
      }
    </div>
  </div>
</section>
